import {
  defaultTenantCountryCode,
  getCountryOptions,
  isValidCountryCode,
  normalizeCountryCodeInput,
} from '@/lib/country-codes'
import { sanitizeEntityLocationPart } from '@/utils/format-entity-location'

/** Map stored profile/org country to ISO code for CountrySelect (handles legacy country names). */
export function entityCountryForEdit(
  country: string | null | undefined,
  locale = 'en-AU',
): string {
  const stored = sanitizeEntityLocationPart(country)
  if (!stored) return ''

  const looksLikeIsoCode = /^[a-zA-Z]{2}$/.test(stored)
  const asCode = looksLikeIsoCode ? normalizeCountryCodeInput(stored) : ''
  if (asCode && isValidCountryCode(asCode, locale)) return asCode

  const byLabel = getCountryOptions(locale).find(
    (option) => option.label.toLowerCase() === stored.toLowerCase(),
  )
  if (byLabel) return byLabel.code

  return ''
}

/** Default when creating new entity location drafts (matches job posting default). */
export function defaultEntityCountryCode(locale = 'en-AU'): string {
  return defaultTenantCountryCode(locale)
}

export function normalizeEntityCountryCode(raw: string): string {
  return normalizeCountryCodeInput(raw)
}
